<template>
	<el-table
			:span-method="arraySpanMethod"
			v-if=" !loading && show && updatePoints && tableData.length > 0"
			height="100%"
			:data="tableData"
			style="width: 100%">
		<el-table-column
				fixed
				prop="loopName"
				label="回路名称"
				width="220"
		>
		</el-table-column>

		<el-table-column
				fixed
				prop="node"
				label="参数名称"
				width="200">
		</el-table-column>

		<el-table-column
				v-for="(item, index) in titles"
				:key="index"
				:prop="item"
				:label="item"
				width="108">
		</el-table-column>

	</el-table>
	<div v-else class="row-center tip">
		<img v-if="loading" src="../../../assets/img/loading.png" class="loading">
		<img v-else src="../../../assets/img/not_found_data.png" alt="">
	</div>
</template>

<script>
	import {floatFormat} from "../../../util/MathUtil"
	import {currentDay, monthDays} from "../../../util/DateUtil";
	import {LOOP_DIAGRAM_DATA_BY_DAY, LOOP_DIAGRAM_DATA_BY_MONTH, LOOP_DIAGRAM_DATA_BY_YEAR} from "../../../api/power";
	import exportExcel from "../../../util/excel";
	import Axios from "axios"
	import dict from "../../../util/dict"

	const UNIT = {
		"PF": "",
		"PFa": "",
		"PFb": "",
		"PFc": "",
		"PA": "(kW)",
		"PAa": "(kW)",
		"PAb": "(kW)",
		"PAc": "(kW)",
		"PR": "(kVar)",
		"PRa": "(kVar)",
		"PRb": "(kVar)",
		"PRc": "(kVar)",
		"P": "(kVA)",
		"Pa": "(kVA)",
		"Pb": "(kVA)",
		"Pc": "(kVA)",
		"F": "(Hz)",
		"Ua": "(V)",
		"Ub": "(V)",
		"Uc": "(V)",
		"Uab": "(V)",
		"Ubc": "(V)",
		"Uac": "(V)",
		"Ia": "(A)",
		"Ib": "(A)",
		"Ic": "(A)",
	}

	export default {
		props: {
			loops: Array,
			nodes: Array,
			range: String,
			date: Date
		},
		name: "Running",
		data() {
			return {
				currentCancelTokenSource: null,
				loading: false,
				show: false,
				allPoints: {},
				titles: [],
			}
		},
		mounted() {
			this.getPoints(this.loops, this.nodes, Axios.CancelToken.source())
		},
		computed: {
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
			updatePoints() {
				return [this.loops, this.date, this.range, this.nodes]
			},
			tableData() {
				let data = []
				this.loops.forEach(l => {
					this.nodes.forEach(n => {
						let points = this.allPoints[n + "_" + l.loopId];
						let obj = {
							loopName: l.loopName,
							node: n,
						}

						this.tableRowInit(obj)
						if (!points) {
							return []
						}
						points.forEach(p => {
							if(n!="PF"&&n!="PFa"&&n!="PFb"&&n!="PFc"){
								obj[this.keyGenerate(p.time)] = floatFormat(p.val.replace(/-/g,''), 2)
							}else{
								obj[this.keyGenerate(p.time)] = floatFormat(p.val.replace(/-/g,''), 2)
							}
							
						})
						obj.node = `${dict(n)}${UNIT[n]}`;
						data.push(obj)
					})
				})

				return data
			},
		},
		methods: {
			keyGenerate(time) {
				let date = new Date(time)
				switch (this.range) {
					case "day":
						let hours = date.getHours();
						return hours < 10 ? '0' + hours + ':00' : hours + ':00'
					case "month":
						return currentDay(date) + '日'
					case "year":
						return date.getMonth() + 1 + '月'
				}
			},
			async getPoints(loops, nodes, source) {

				this.currentCancelTokenSource = source

				this.allPoints = {}
				if (!loops) {
					return
				}
				this.loading = true


				let promises = []

				for (let i = 0; i < loops.length; i++) {
					let l = loops[i]
					let temp = nodes.map(n => {

						switch (this.range) {
							case "day":
								this.titles = []
								for (let i = 0; i < 24; i++) {
									this.$set(this.titles, i, i < 10 ? '0' + i + ':00' : i + ':00')
								}
								return LOOP_DIAGRAM_DATA_BY_DAY(l.loopId, n, this.date, source)
							case "month":
								this.titles = []
								for (let i = 0; i < monthDays(this.date); i++) {
									this.$set(this.titles, i, i + 1 + '日')
								}
								return LOOP_DIAGRAM_DATA_BY_MONTH(l.loopId, n, this.date, source)
							case "year":
								this.titles = []
								for (let i = 0; i < 12; i++) {
									this.$set(this.titles, i, i + 1 + '月')
								}
								return LOOP_DIAGRAM_DATA_BY_YEAR(l.loopId, n, this.date, source)
						}

					})
					this.savePoints(temp, nodes, l)
					promises = promises.concat(temp)
				}

				await Promise.all(promises)
				this.loading = false
			},
			async savePoints(promises, nodes, l) {
				let res = await Promise.all(promises)
				nodes.forEach((n, j) => {
					this.$set(this.allPoints, `${n}_${l.loopId}`, res[j].data? res[j].data.data.points : [])
				})
				return res
			},
			arraySpanMethod({row, column, rowIndex, columnIndex}) {
				let i = this.nodes.length
				if (columnIndex === 0 && i > 1) {
					if (rowIndex % i !== 0) {
						return [0, 0]
					} else {
						return [i, 1]
					}
				}
			},
			reShow() {
				this.show = false
				this.$nextTick(() => {
					this.show = true
				})
			},

			tableRowInit(obj) {
				this.titles.forEach(k => {
					obj[k] = '--'
				})
			},

		},
		watch: {
			diagramStatus(n){
				if(this.$route.params.name === 'Running' && this.$route.params.tag === 'none' ){
					if(n.type === 'excel' && this.tableData.length > 0){

						let data = [
							['回路名称', '参数名称']
						]

						let merges = [

						]

						this.titles.forEach(t => {
							data[0].push(t)
						})

						let len = this.nodes.length

						this.tableData.forEach((d, i) => {
							data.push([i % len === 0 ? d.loopName : null, d.node, ...this.titles.map(t => d[t])])

							if(i % len === 0){
								merges.push({s: {r: 1 + i, c: 0}, e: {r: len + i, c: 0}})
							}
						})

						exportExcel(data, '电力运行报表', merges)

					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
			updatePoints(n) {
				this.currentCancelTokenSource.cancel("请求取消")
				this.reShow()
				this.getPoints(this.loops, this.nodes, Axios.CancelToken.source())
				
				console.log(this.loops,"this.loops")
			}
		}
	}
</script>

<style scoped lang="less">
	.tip {
		width: 100%;
		height: 100%;
		font-size: 16rem;
		color: #8c939d;
	}

	.loading {
		width: 28rem;
		height: 28rem;
		animation: loading 1s linear infinite;
	}

	@keyframes loading {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>